import { forwardRef, ReactNode } from 'react';

import { Typography } from '@mui/material';

import clsx from 'clsx';
import Link, { LinkProps } from 'next/link';

type NavLinkProps = LinkProps & {
  className?: string;
  children?: ReactNode;
  title?: string;
};

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, className, onClick, ...linkProps }: NavLinkProps, ref) => {
    return (
      <Link {...linkProps} className={clsx(className)} passHref>
        <Typography variant="button" onClick={onClick}>
          {children}
        </Typography>
      </Link>
    );
  }
);

export const NavLinkRegular = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, className, onClick, ...linkProps }, ref) => {
    return (
      <Link {...linkProps} className={clsx(className)} passHref>
        <Typography variant="body1" onClick={onClick}>
          {children}
        </Typography>
      </Link>
    );
  }
);

export const NavLinkRaw = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, className, onClick, title, ...linkProps }, ref) => {
    return (
      <Link {...linkProps} title={title} onClick={onClick} className={clsx(className)} passHref>
        {children}
      </Link>
    );
  }
);
